var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8445 10.3727L9.49905 8.03122C9.38178 7.93756 9.24105 7.86732 9.10033 7.86732H8.72506C9.35833 7.0478 9.75705 6.01756 9.75705 4.87024C9.75705 2.20098 7.55233 0 4.87853 0C2.18126 0 0 2.20098 0 4.87024C0 7.56293 2.18126 9.74049 4.87853 9.74049C6.00434 9.74049 7.03634 9.36585 7.8807 8.71024V9.10829C7.8807 9.24878 7.92761 9.38927 8.04488 9.50634L10.3669 11.8244C10.6014 12.0585 10.9532 12.0585 11.1643 11.8244L11.821 11.1688C12.0556 10.958 12.0556 10.6068 11.8445 10.3727ZM4.87853 7.86732C3.21326 7.86732 1.87636 6.53268 1.87636 4.87024C1.87636 3.23122 3.21326 1.87317 4.87853 1.87317C6.52034 1.87317 7.8807 3.23122 7.8807 4.87024C7.8807 6.53268 6.52034 7.86732 4.87853 7.86732Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassSm);
export default __webpack_public_path__ + "static/media/magnifying_glass_sm.136ebb8b6dd77014a8efb42d6b2ee504.svg";
export { ForwardRef as ReactComponent };